import type {
  UserListUserAssetTransfersParams,
  UserUserAssetTransferInput,
  UserCheckBuyoutEligibilityParams,
} from '../api'
import { api } from '../api'

export const transferUserAsset = async (data: UserUserAssetTransferInput) => {
  return await api.v1.userTransferUserAsset(data)
}

export const listUserAssetTransfers = async (
  data: UserListUserAssetTransfersParams,
) => {
  return await api.v1.userListUserAssetTransfers({ ...data })
}

export const checkBuyoutEligibility = async (
  data: UserCheckBuyoutEligibilityParams,
) => {
  return await api.v1.userCheckBuyoutEligibility(data)
}
